module.exports = __webpack_public_path__ + "static/img/13一种弯管机进给装置.6eee5087.jpg";